<template>
  <v-icon
    :icon="mdiAccount"
    size="16"
    color="white"
    class="h-25 w-25"
  />
  <v-app>
    <v-main>
      <v-container
        class="general-style"
        fluid
        fill-height
        fill-width
      >
        <v-layout
          align-center
          class="layout-style"
        >
          <v-card
            class="elevation-12 card-style"
          >
            <v-toolbar
              dark
              color="primary"
            >
              <v-toolbar-title class="title-style">
                Register
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <form
                ref="form"
                @submit.prevent="register()"
              >
                <v-text-field
                  v-model="firstname"
                  name="firstname"
                  label="First Name"
                  type="text"
                  required
                />

                <v-text-field
                  v-model="lastname"
                  name="lastName"
                  label="Last Name"
                  type="text"
                  required
                />

                <v-text-field
                  v-model="email"
                  name="email"
                  label="Email"
                  type="text"
                  required
                />

                <v-text-field
                  v-model="password"
                  name="password"
                  label="Password"
                  type="password"
                  required
                />
                <v-text-field
                  v-model="confirmPassword"
                  name="confirmPassword"
                  label="Confirm Password"
                  type="password"
                  required
                />
                <v-alert
                  v-if="errorMessage"
                  type="error"
                  variant="tonal"
                  class="mb-3"
                  density="compact"
                  :icon="false"
                >
                  {{ errorMessage }}
                </v-alert>
                <v-btn
                  type="submit"
                  class="ns-btn-primary mt-4"
                  :elevation="0"
                  value="register"
                  :disabled="loading"
                >
                  <template v-if="loading">
                    <v-progress-circular
                      indeterminate
                      color="white"
                      size="20"
                      class="mr-2"
                    />
                    Loading...
                  </template>
                  <template v-else>
                    Register
                  </template>
                </v-btn>
                <v-card-text class="text-center mt-3 agreement-text">
                  By signing up, I agree to Immersive's
                  <router-link
                    to="/terms-of-use"
                    class="text-decoration-none agreement-link"
                  >
                    Terms of Use
                  </router-link>
                </v-card-text>
              </form>
            </v-card-text>
          </v-card>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { postWithAuthentication } from "@/services/api";
import { 
    BASE_URL, 
    REGISTER_API_ENDPOINT 
  } from "@/assets/constants/api_endpoints";
import { 
    PASSWORD_MISMATCH_ERR_MSG, 
    REGISTRATION_FAILED, 
    REGISTRATION_SUCCESS 
  } from "@/assets/constants/constants.js";
import "../assets/css/common.css";

export default {
  name: "RegisterForm",
  data() {
    return {
      firstname: "",
      lastname: "",
      email: "",
      password: "",
      confirmPassword: "",
      PASSWORD_MISMATCH_ERR_MSG,
      loading: false,
      errorMessage: "",
    };
  },
  methods: {
    async handleRegister(registerInfo) {
      this.loading = true;
      try {
        await postWithAuthentication(BASE_URL, REGISTER_API_ENDPOINT, registerInfo);
        this.$router.push({ name: "LoginForm", query: { infoMessage: REGISTRATION_SUCCESS } });
      } catch (error) {
        this.errorMessage = REGISTRATION_FAILED;
      } finally {
        this.loading = false;
      }
    },
    register() {
      if (this.loading) return;
      if (this.password !== this.confirmPassword) {
        this.errorMessage = PASSWORD_MISMATCH_ERR_MSG;
        return;
      }
      this.errorMessage = "";
      const userInfo = {
        first_name: this.firstname,
        last_name: this.lastname,
        email: this.email,
        password: this.password,
      };
      this.handleRegister(userInfo);
    },
  },
};
</script>

<style scoped>
:deep(.v-toolbar__content > .v-toolbar-title) {
  margin-inline-start: 0;
}

.card-style {
  max-width: 450px;
  border-radius: var(--radius-lg);
  border: 1px solid rgba(27,30,100,0.10);
  box-shadow: none;
  overflow: hidden;
  height: auto;
}

.title-style {
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 0.5px;
  color: white;
}

.layout-style {
  justify-content: center;
  padding: 20px;
}

.general-style {
  background-color: var(--color-bg);
  min-height: 100vh;
}

form {
  padding: 0;
}

:deep(.v-text-field__control) input {
  font-size: 14px;
  border-radius: 8px;
}

:deep(.v-field__outline) {
  color: #e0dff0;
}

:deep(.v-field.v-field--focused .v-field__outline) {
  color: var(--color-primary-mid);
}

:deep(.v-label.v-field-label) {
  color: #7a7a8a;
  font-size: 14px;
}

:deep(.v-field.v-field--focused .v-label.v-field-label) {
  color: var(--color-primary-mid);
}

.v-btn {
  width: 100%;
  height: 44px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  text-transform: capitalize;
}

.agreement-text {
  font-size: 0.8rem;
  color: #7a7a8a;
  padding: 0 !important;
  margin-top: 16px;
  line-height: 1.5;
}

.agreement-text a,
.agreement-link {
  color: var(--color-primary);
  font-weight: 500;
  text-decoration: underline;
  transition: color 0.2s ease;
}

.agreement-text a:hover,
.agreement-link:hover {
  color: var(--color-primary-dark);
}

</style>

